import { getCountry } from '@iwIntlProvider/CountryProvider';
import { FormattedMessage } from 'react-intl';

import styles from './WithdrawalFee.module.css';
import LoadingCalculationValue from '../../../../multiLoanDashboard/dashboardComponents/loadingDashboardValue/LoadingDashboardValue';
import { VariableRate } from '../../../../ui/rate/Rate';
import SummaryRow from '../../../../ui/summaryRow/SummaryRow';

const WithdrawalFee = ({ withdrawalFee, className }) => {
    return (
        <SummaryRow data-testid="withdrawal-fees" className={className}>
            <FormattedMessage
                id="_.draw_down.choose_amount.withdrawal_fee"
                defaultMessage="Withdrawal fee"
            />

            <LoadingCalculationValue>
                <div>
                    {withdrawalFee === 0 && getCountry() === 'DE' && (
                        <span className={styles.always}>
                            <FormattedMessage
                                id="_.draw_down.choose_amount.always"
                                defaultMessage="always"
                            />
                        </span>
                    )}

                    <VariableRate
                        minimumFractionDigits={0}
                        maximumFractionDigits={2}
                        value={withdrawalFee}
                    />
                </div>
            </LoadingCalculationValue>
        </SummaryRow>
    );
};

// eslint-disable-next-line import/no-default-export
export default WithdrawalFee;
